import React from 'react';
import { Skeleton } from 'antd';
import { Radius } from '@common/tokens';

export const Input = ({
  loading,
  size,
  children,
  width,
  radius,
}: {
  loading?: boolean;
  size?: 'large' | 'small' | 'default';
  width?: number;
  radius?: boolean;
  children: React.ReactNode;
}) => (
  <>
    {loading ? (
      <Skeleton.Input
        className="Placeholder Input"
        size={size}
        active={true}
        style={{
          width,
          borderRadius: radius ? Radius.sm : undefined,
        }}
      />
    ) : (
      children
    )}
  </>
);
